import { render, staticRenderFns } from "./AuditPenalty.vue?vue&type=template&id=a97d82c0&scoped=true&"
import script from "./AuditPenalty.vue?vue&type=script&lang=js&"
export * from "./AuditPenalty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97d82c0",
  null
  
)

export default component.exports